export const getRowsAccordingToUserType = (rowsData = [] as any, userEmail = '', name = '', businessUserId = '') => {
   if (!Array.isArray(rowsData)) {
      return []
   }

   return rowsData?.filter((data: Record<string, string>) => {
      if (data?.businessUserId) {
         return data?.businessUserId === businessUserId
      }
      if (data?.email) {
         return data?.email?.toLowerCase() === userEmail?.toLowerCase() && data?.userName?.trim()?.toLowerCase() == name?.trim().toLowerCase()
      }
      return false
   })
} 